// Phase 10d-4 — homecare-client PaymentMethod admin/portal schemas.
//
// The portal flow has three steps:
//   1. POST /me/payment-methods/setup-intent     → server returns
//      { clientSecret, setupIntentId } for Stripe Elements to confirm.
//   2. Portal confirms the SetupIntent client-side via stripe.js.
//   3. POST /me/payment-methods (with the resulting payment_method_id)
//      → server attaches + saves the row + optionally sets as default.
//
// Removal: DELETE /me/payment-methods/:id → row hard-deleted + Stripe
// PaymentMethod detached (best-effort; Stripe errors log + continue).
//
// One-off cards (save-by-default opt-out at booking) are not exposed
// here — they live as ephemeral Stripe PaymentMethods attached only
// for the single PaymentIntent.
import { z } from 'zod';
// ===== shared pieces =====
const StripePaymentMethodIdSchema = z
    .string()
    .regex(/^pm_[A-Za-z0-9]+$/, 'Stripe PaymentMethod ids start with pm_');
const StripeSetupIntentIdSchema = z
    .string()
    .regex(/^seti_[A-Za-z0-9]+$/, 'Stripe SetupIntent ids start with seti_');
// ===== responses =====
export const PaymentMethodResponseSchema = z.object({
    id: z.string().uuid(),
    brand: z.string(),
    last4: z.string().length(4),
    expMonth: z.number().int().min(1).max(12),
    expYear: z.number().int().min(2024).max(2099),
    isDefault: z.boolean(),
    isExpired: z.boolean(),
    createdAt: z.string().datetime(),
});
export const PaymentMethodListResponseSchema = z.object({
    items: z.array(PaymentMethodResponseSchema),
});
// ===== config (publishable key for Stripe Elements) =====
/**
 * Served to the portal so Stripe Elements can tokenize a card in the
 * browser. `publishableKey` is null when Stripe isn't configured — the
 * portal hides the add-card affordance and points the client at the
 * operator instead.
 */
export const PaymentConfigResponseSchema = z.object({
    publishableKey: z.string().nullable(),
});
// ===== setup-intent =====
export const SetupIntentRequestSchema = z.object({}).strict();
export const SetupIntentResponseSchema = z.object({
    clientSecret: z.string(),
    setupIntentId: StripeSetupIntentIdSchema,
    customerId: z.string(), // Stripe cus_xxx — Stripe Elements may want it
});
// ===== attach (POST /me/payment-methods) =====
export const AttachPaymentMethodRequestSchema = z.object({
    stripePaymentMethodId: StripePaymentMethodIdSchema,
    setAsDefault: z.boolean().default(false),
});
// ===== mutations =====
export const SetDefaultPaymentMethodRequestSchema = z.object({}).strict();
//# sourceMappingURL=payment-method.schema.js.map